import { put } from "redux-saga/effects";
import importer from "common/importer";
/* ENDPOINTS */
const {
  deloit: { sendMfaCode },
} = importer("APIs/auth", null);
/* ACTIONS */
const UserActions = importer("Stores/Users/Actions");
export default function* main({ userId, factorType }) {
  try {
    yield put(UserActions.sendMfaCodeLoading());
    const res = yield sendMfaCode({ userId, factorType });
    if (res.data?.isError) {
      yield put(
        UserActions.sendMfaCodeFailure({ response: { data: res.data } })
      );
    } else {
      yield put(UserActions.sendMfaCodeSuccess(res));
    }
  } catch (error) {
    yield put(UserActions.sendMfaCodeFailure(error));
  }
}
